import { Select } from "antd";
import { useAccount } from "../../hooks/use-account";
import { useEffect, useMemo, useState } from "react";
import { apiRequest } from "../../api";

export const MemberMarker = () => {
  interface Member {
    id: string;
    name: string;
    weekly_agenda: boolean;
  }

  const {
    vojomoAccount,
    companyName,
    updateImpersonatedCompany,
    isUpdatingCompany
  } = useAccount();

  if (vojomoAccount?.company !== "Vojomo") {
    return <></>;
  }

  const [members, setMembers] = useState<Member[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  const filteredMembers = useMemo(() => {
    return members
      .filter((member) => member.name !== companyName)
      .map((member) => {
        return { value: member.name };
      });
  }, [members, companyName]);

  const callApiMembers = async () => {
    setIsLoading(true);

    try {
      const data = await apiRequest<Member[]>({
        subRoute: "utils",
        path: "/members"
      });

      if (data) {
        setMembers(data);
      }
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    callApiMembers();
  }, []);

  if (filteredMembers.length === 0) {
    return (
      <span style={{ fontWeight: "700", fontSize: 14, color: "#ff6c6c" }}>
        {companyName}
      </span>
    );
  }

  return (
    <div className="qbr-member-marker" style={{ width: "fit-content" }}>
      <Select
        value={companyName}
        variant="borderless"
        showSearch={isOpen}
        open={isOpen}
        onOpenChange={setIsOpen}
        filterOption={(input, option) =>
          (option?.value ?? "").toLowerCase().includes(input.toLowerCase())
        }
        onChange={async (value) => {
          await updateImpersonatedCompany(value);
        }}
        loading={isLoading || isUpdatingCompany}
        options={filteredMembers}
        disabled={isLoading}
        popupMatchSelectWidth={false}
        labelRender={(item) => (
          <span style={{ fontWeight: "700", color: "#ff6c6c" }}>
            {item?.value}
          </span>
        )}
      />
    </div>
  );
};
